<script>
import Slider from "@vueform/slider";

export default {
  name: "RangeFliter",
  components: {
    Slider,
  },
  props: {
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    minStep: {
      type: Number,
      default: 1,
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  /*
  data() {
    return {
      value: [this.min, this.max],
    };
  },
  */
  computed: {
    value: {
      get() {
        return (this.modelValue || this.min + "," + this.max)
          .split(",")
          .map((value) => parseFloat(value));
      },
      set(value) {
        this.$emit("update:modelValue", value[0] + "," + value[1]);
      },
    },
    step() {
      const diff = this.max - this.min;
      const log = Math.floor(Math.log10(diff)) - 2;
      let step = Math.pow(10, log);

      if (step < this.minStep) {
        step = this.minStep;
      }

      return step;
    },
  },
};
</script>

<template>
  <div class="range-filter">
    <Slider
      class="slider"
      v-model="value"
      :min="min"
      :max="max"
      :step="step"
      :tooltips="false"
    />
    <div class="values">
      <div class="value">{{ $numberFormat(value[0]) }}</div>
      <div class="value">{{ $numberFormat(value[1]) }}</div>
    </div>
  </div>
</template>

<style src="@vueform/slider/themes/default.css"></style>

<style lang="scss" scoped>
.range-filter {
  padding-top: 26px;
  padding-left: 8px;
  padding-right: 9px;
}

.slider {
  box-shadow: -8px 0 0 $color-border, 9px 0 0 $color-border;
}

.values {
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  justify-content: space-between;
  margin: 18px -9px 0 -8px;
  font-size: 12px;
}
</style>
